export class Permissions {
  //User Managment Permissions
  READ_USER_MANAGMENT = "Permissions.UserManagment.Read";

  //Master Data Permissions
  READ_MASTER_DATA = "Permissions.MasterData.Read";

  //Transaction Permissions
  READ_TRANSACTION = "Permissions.Transactions.Read";

  //Administration Permissions
  READ_ADMINISTRATION = "Permissions.Administration.Read";

  //Driver Trips
  READ_DRIVER_TRIPS="Permissions.DriverTrips.Read";

  //vehicle tracking
  READ_VEHICLE_TRACKING = "Permissions.Tracking.Read";
 
  //ADMINISTRATION_DRIVER_TRIPS = "Permissions.Administration.Is_Driver";
  //ADMINISTRATION_SALES_AGENT="Permissions.Administration.Is_SalesAgent";
  //ADMINISTRATION_CUSTOMER="Permissions.Administration.Is_Customer";
  // User Permissions
  CREATE_USER = "Permissions.User.Create";
  READ_USER = "Permissions.User.Read";
  UPDATE_USER = "Permissions.User.Update";
  DELETE_USER = "Permissions.User.Delete";

  // Role Permissions
  CREATE_ROLE = "Permissions.Role.Create";
  READ_ROLE = "Permissions.Role.Read";
  UPDATE_ROLE = "Permissions.Role.Update";
  DELETE_ROLE = "Permissions.Role.Delete";
  ASSIGN_PERMSSIONS = "Permissions.Role.Assign_Permissions";

  // Transporter Permissions
  CREATE_TRANSPORTER = "Permissions.Transporter.Create";
  READ_TRANSPORTER = "Permissions.Transporter.Read";
  UPDATE_TRANSPORTER = "Permissions.Transporter.Update";
  DELETE_TRANSPORTER = "Permissions.Transporter.Delete";

  // Factory Permissions
  CREATE_FACTORY = "Permissions.Factory.Create";
  READ_FACTORY = "Permissions.Factory.Read";
  UPDATE_FACTORY = "Permissions.Factory.Update";
  DELETE_FACTORY = "Permissions.Factory.Delete";

  // Order Permissions
  CREATE_ORDER = "Permissions.Order.Create";
  READ_ORDER = "Permissions.Order.Read";
  UPDATE_ORDER = "Permissions.Order.Update";
  DELETE_ORDER = "Permissions.Order.Delete";
  VIEW_ALL_ORDERS = "Permissions.Order.View_All";

  // Vehicle Permissions
  CREATE_VEHICLE = "Permissions.Vehicle.Create";
  READ_VEHICLE = "Permissions.Vehicle.Read";
  UPDATE_VEHICLE = "Permissions.Vehicle.Update";
  DELETE_VEHICLE = "Permissions.Vehicle.Delete";
  //ASSIGN_DRIVERS = "Permissions.Vehicle.Assign_Drivers";

    // Vehicle Permissions
    CREATE_DRIVER = "Permissions.Driver.Create";
    READ_DRIVER = "Permissions.Driver.Read";
    UPDATE_DRIVER = "Permissions.Driver.Update";
    DELETE_DRIVER = "Permissions.Driver.Delete";

  //Loading Order Permissions
  CREATE_LOADING_ORDER = "Permissions.LoadingOrder.Create";
  READ_LOADING_ORDER = "Permissions.LoadingOrder.Read";
  UPDATE_LOADING_ORDER = "Permissions.LoadingOrder.Update";
  DELETE_LOADING_ORDER = "Permissions.LoadingOrder.Delete";
  DRIVER_TRIPS = "Permissions.LoadingOrder.DriverOwnTrips";

  //Sales Quotation Permissions
  CREATE_SALES_QUOTATION = "Permissions.SalesQuotation.Create";
  READ_SALES_QUOTATION = "Permissions.SalesQuotation.Read";
  UPDATE_SALES_QUOTATION = "Permissions.SalesQuotation.Update";
  DELETE_SALES_QUOTATION = "Permissions.SalesQuotation.Delete";
  HIDE_QUOTATION_PRICE="Permissions.SalesQuotation.HideQuotationPrice";
  CAN_ACCEPT_QUOTATION="Permissions.SalesQuotation.CanAcceptQuotation";
  //Sales order Permissions
  CREATE_SALES_ORDER = "Permissions.SalesOrder.Create";
  READ_SALES_ORDER = "Permissions.SalesOrder.Read";
  UPDATE_SALES_ORDER = "Permissions.SalesOrder.Update";
  DELETE_SALES_ORDER = "Permissions.SalesOrder.Delete";

  //purchase order Permissions
  CREATE_PURCHASE_ORDER = "Permissions.PurchaseOrder.Create";
  READ_PURCHASE_ORDER = "Permissions.PurchaseOrder.Read";
  UPDATE_PURCHASE_ORDER = "Permissions.PurchaseOrder.Update";
  DELETE_PURCHASE_ORDER = "Permissions.PurchaseOrder.Delete";
  COPY_PURCHASE_ORDER ="Permissions.PurchaseOrder.CopyToSalesOrder";
 
  //sales delivery Permissions
  READ_SALES_DELIVERY = "Permissions.SalesDelivery.Read";

  // Report Permissions
  READ_REPORT = "Permissions.Report.Read";
  READ_FINANCIAL_STATEMENT_REPORT="Permissions.Report.FinancialStatementReport"
  
  // Configuration Permissions
  UPDATE_CONFIG = "Permissions.Configuration.Update";

  // Admin Permissions
  //IS_ADMIN = "Permissions.Admin.Is_Admin";

  // Delivery Note Permissions
  CREATE_DELIVERY_NOTE = "Permissions.DeliveryNote.Create";
  READ_DELIVERY_NOTE = "Permissions.DeliveryNote.Read";
  UPDATE_DELIVERY_NOTE = "Permissions.DeliveryNote.Update";
  DELETE_DELIVERY_NOTE = "Permissions.DeliveryNote.Delete";
  VIEW_DELIVERY_NOTE_DETAILS = "Permissions.DeliveryNote.View_Details";
  VIEW_ALL_DELIVERY_NOTE = "Permissions.DeliveryNote.View_All";
  CONFIRM_DELIVERY_NOTE_ITEMS = "Permissions.DeliveryNote.Confirm_Items";
  ASSIGN_DELIVERY_NOTE_VEHICLE = "Permissions.DeliveryNote.Assign_Vehicles";
  SET_VEHICLEKILOMETER_DELIVERY_NOTE =
    "Permissions.DeliveryNote.Set_VehicleKilometer";
  RECEIVE_DELIVERY_ORDER = "Permissions.DeliveryNote.Receive_Order";
  ADD_DELIVERY_FUEL = "Permissions.DeliveryNote.Add_Fuel";
  DRIVER_RECEIVE_DELIVERY_ORDER =
    "Permissions.DeliveryNote.Driver_Receive_Order";
  ADMIN_RECEIVE_DELIVERY_ORDER = "Permissions.DeliveryNote.Admin_Receive_Order";
  EDIT_DELIVERY_WAREHOUSE = "Permissions.DeliveryNote.Edit_Warehouses";
  ADD_DELIVERY_OTP = "Permissions.DeliveryNote.Add_OTP";
  SYNC_DELIVERY = "Permissions.DeliveryNote.Sync";
  ADD_DELIVERY_NOTE_ADDITIONAL_AMOUNT =
    "Permissions.DeliveryNote.Add_Additional_Amount";
  REMOVE_DELIVERY_NOTE_ADDITIONAL_AMOUNT =
    "Permissions.DeliveryNote.Remove_Additional_Amount";
  VIEW_ALL_DELIVERY_NOTE_STATUS = "Permissions.DeliveryNote.View_All_Status";
  
  //customer Permissions
  CREATE_CUSTOMER = "Permissions.Customer.Create";
  READ_CUSTOMER = "Permissions.Customer.Read";
  UPDATE_CUSTOMER = "Permissions.Customer.Update";
  DELETE_CUSTOMER = "Permissions.Customer.Delete";
  //CAN_SET_CUSTOMER_ADDRESS = "Permissions.Customer.Set_Google_Address";

  //product Permissions
  READ_PRODUCT = "Permissions.Product.Read";
  //ATTACH_PRODUCT_IMAGE = "Permissions.Product.Attach_Image";
  //PRODUCT_EDIT_WAREHOUSE = "Permissions.Product.Edit_Warehouse";
  //PRODUCT_EDIT_CATEGORY = "Permissions.Product.Edit_Category";
  //PRODUCT_PRINT_BARCODE = "Permissions.Product.Print_Barcode";
  //PRODUCT_CHANGE_STATUS = "Permissions.Product.Change_Status";

  //dashboard Permissions
  VIEW_WIDGETS = "Permissions.Dashboard.View_Widgets";
  VIEW_MAP = "Permissions.Dashboard.View_Map";

}
